"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _provider = _interopRequireDefault(require("../../provider"));
var _BrightSignNativeService = _interopRequireDefault(require("./BrightSignNativeService"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class BrightSignMetricsProvider extends _provider.default {
  /**
     * @override
     * @returns {Promise<DeviceMetrics|null>} null if the BrightSign server is unreachable
     */
  collectAll() {
    return _BrightSignNativeService.default.collectAll();
  }
  getConnectionType() {
    return _BrightSignNativeService.default.getConnectionType();
  }
  getNetworkMetrics() {
    return _BrightSignNativeService.default.getNetworkMetrics();
  }
  getSystemMetrics() {
    return _BrightSignNativeService.default.getSystemMetrics();
  }
  getDeviceName() {
    return _BrightSignNativeService.default.getDeviceName();
  }
  getDeviceId() {
    return _BrightSignNativeService.default.getDeviceId();
  }
}
var _default = exports.default = BrightSignMetricsProvider;